/** @jsxImportSource @emotion/react */

import { Card } from "@jsq/ds/core";
import { SubmitButton, useFormContext } from "@jsq/ds/forms";
import { FormValues } from "../types";

export type RoleObjectType =
  | {
      name: string | null;
      __typename?: "RoleObjectType" | undefined;
      id: string;
      description: string | null;
      isManageBasicConfigurationSetting: boolean;
      isManageStaffAccessSetting: boolean;
      isManageAdminConfigurationSetting: boolean;
    }[]
  | undefined;

const TestAnnouncementCard = () => {
  const { setFieldValue } = useFormContext<FormValues>();
  return (
    <Card title="Test announcement">
      <SubmitButton
        variant="primary"
        isFullWidth
        onClick={() => setFieldValue("isTestAnnouncement", true)}
      >
        Send test to Rockstone Capital
      </SubmitButton>
    </Card>
  );
};

export default TestAnnouncementCard;
